export default __webpack_public_path__ + "static/media/4967.897faff4.png";